import React, { FC, useEffect } from 'react'
import t from '../../../../../translations/main'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'
import { useCountryOfResidences } from 'src/components/Core/Context/OnboardingContext'

const TaxResidencyForm: FC<FormProps> = props => {
  const tableData = useCountryOfResidences()

  const submitForm = ({data, options}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options })
  }
  const {
    setFormData,
    formData,
    emptyValidation,
    toggleShowByVisualName,
    toggleShowBySecondaryName,
    toggleShowByName,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(
    props.fetchedData,
    config,
    submitForm
  )

  useEffect(() => {
    toggleShowBySecondaryName('giinNo', ['anInvestmentEntity', 'otherInvestment', 'financialInstitution'].includes(formData?.eAccountHoldersStatus?.value) ? `${formData?.eAccountHoldersStatus?.value}-inputs` : '')

    toggleShowByVisualName('anInvestmentEntity-fileInput', formData?.eAccountHoldersStatus?.value === 'anInvestmentEntity' ? 'true' : 'false')
    toggleShowByVisualName('anInvestmentEntity-controllingPersonsTemplate', formData?.eAccountHoldersStatus?.value === 'anInvestmentEntity' ? 'true' : 'false')
    toggleShowByVisualName('anInvestmentEntity-controllingPersonText', formData?.eAccountHoldersStatus?.value === 'anInvestmentEntity' ? 'true' : 'false')
    toggleShowByVisualName('passiveNFE-fileInput', formData?.eAccountHoldersStatus?.value === 'passiveNFE' ? 'true' : 'false')
    toggleShowByVisualName('passiveNFE-controllingPersonsTemplate', formData?.eAccountHoldersStatus?.value === 'passiveNFE' ? 'true' : 'false')
    toggleShowByVisualName('passiveNFE-controllingPersonText', formData?.eAccountHoldersStatus?.value === 'passiveNFE' ? 'true' : 'false')

  },[formData?.eAccountHoldersStatus?.value])

  useEffect(() => {
    toggleShowByVisualName('nonUsPersonText', formData?.isaUSPerson?.value === 'false' ? 'true' : 'false')
    toggleShowByName('isUSProducts', formData?.isaUSPerson?.value === 'false')
    toggleShowByVisualName('w8ben-fileInput', formData?.isaUSPerson?.value === 'false' ? 'true' : 'false')

    toggleShowByVisualName('w9-fileInput', formData?.isaUSPerson?.value === 'true' ? 'true' : 'false')
    toggleShowByName('formW9', formData?.isaUSPerson?.value === 'true')

  },[formData?.isaUSPerson?.value])

  useEffect(() => {
    toggleShowByVisualName('w8ben-fileInput', formData?.isUSProducts?.value === 'true' ? 'true' : 'false')
    toggleShowByName('formW8BEN', formData?.isUSProducts?.value === 'true')
  },[formData?.isUSProducts?.value])

  useEffect(() => {
    // @ts-ignore
    setFormData(prev => {
      // @ts-ignore
      if(prev.controllingPersonsForm.value.constructor === Object && prev.controllingPersonsForm.value.documentName === null) prev.controllingPersonsForm.value = []
      return prev
    })
  },[])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.TaxResidencyForm.title')}
        </FormTitle>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation ||
              !formData?.eAccountHoldersStatus?.value ||
              tableData?.length === 0 ||
             (['anInvestmentEntity', 'passiveNFE'].includes(formData?.eAccountHoldersStatus?.value) && formData.controllingPersonsForm.value.length === 0)
            }
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default TaxResidencyForm
